import React, { memo, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import Container from 'react-bootstrap/Container';

import AcceptanceFeatures from '../Component/Validator/AcceptanceFeatures/AcceptanceFeatures';
import FeedbackButton from '../Component/Validator/FeedbackButton';
import Header from '../Component/General/Header';
import LoadingPage from './LoadingPage';
import ErrorPage from './ErrorPage';
import MortgageProperties from '../Component/Validator/MortgageProperties/MortgageProperties';
import PoweredBy from '../Component/General/PoweredBy';
import ResultContext from '../Context/ResultContext';

import useGetValidatorResponse from '../Hook/Validator/UseGetValidatorResponse';
import useGetLastResponseCode from '../Hook/Interest/UseGetLastResponseCode';
import { StatusCodes } from 'http-status-codes';
import SystemMessagePage from './SystemMessagePage';

type Props = RouteComponentProps<{ caseId: string }>;

const ValidatorResultPage: React.FC<Props> = (props: Props) => {
    const { caseId } = props.match.params;
    const { result, error, isLoading, amountRequests, retry, errorCode } = useGetValidatorResponse(caseId);

    useEffect(() => {
        document.title = 'FinData validator';
    });

    const lastResponseCode = useGetLastResponseCode();

    if (lastResponseCode === StatusCodes.SERVICE_UNAVAILABLE) {
        return <SystemMessagePage />;
    }

    if (error) {
        return <ErrorPage retry={retry}
                          amountRequests={amountRequests}
                          isValidator={true}
                          errorCode={errorCode}
        />;
    }

    if (isLoading) {
        return <LoadingPage amountRequests={amountRequests} />;
    }

    return (
        <ResultContext.Provider value={result}>
            <Header validator={true}>
                <span className="navbar-brand context-validator" />
            </Header>
            <div className="main-wrapper">
                <Container fluid className="main-container">
                    <h2>Overzicht</h2>
                    <Container fluid>
                        <MortgageProperties />
                    </Container>
                    <h2>Acceptatie kenmerken</h2>
                    <Container fluid>
                        <AcceptanceFeatures />
                    </Container>
                    <p className="text-sm-left">
                        Deze indicatie controleert een gedeelte van het acceptatiebeleid van de geldverstrekker. De
                        beoordeling en goedkeuring vindt altijd door de geldverstrekker zelf plaats. Aan deze indicatie
                        kunnen geen rechten ontleend worden.
                    </p>
                    <PoweredBy />
                    <FeedbackButton caseId={props.match.params.caseId} />
                </Container>
            </div>
        </ResultContext.Provider>
    );
};

export default memo(ValidatorResultPage);
